import { render, staticRenderFns } from "./ProcessRelational.vue?vue&type=template&id=591f86bf&scoped=true"
import script from "./ProcessRelational.vue?vue&type=script&lang=js"
export * from "./ProcessRelational.vue?vue&type=script&lang=js"
import style0 from "./ProcessRelational.vue?vue&type=style&index=0&id=591f86bf&prod&lang=scss"
import style1 from "./ProcessRelational.vue?vue&type=style&index=1&id=591f86bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591f86bf",
  null
  
)

export default component.exports